import type { Theme } from '@mui/material';

export const styles = {
  tableCell: (minWidth: string) => (theme: Theme) => ({
    maxWidth: '200px',
    minWidth,
    textOverflow: 'ellipsis',
    textWrap: 'nowrap',
    overflow: 'hidden',
    height: '48px',
    padding: '16px 0 0 16px',
    color: theme.colors.neutral[600],
    fontWeight: 600,
  }),

  wrapper: {
    cursor: 'pointer',
  },
};
